import { productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const InventoryTrackedProductSchema = z.object({
  productId: productIdFormat.schema,
  onHandQuantity: z.number(),
  reorderThreshold: z.number(),
  reorderQuantity: z.number(),
});

const InventoryTrackingDataSchema = z.object({
  locationExternalId: z.string(),
  products: z.array(InventoryTrackedProductSchema),
});

export const createCheckoutSession = {
  name: "createCheckoutSession" as const,
  input: z.object({
    inventoryTrackingData: InventoryTrackingDataSchema.nullish(),
  }),
  output: z.object({ checkoutSessionId: z.string() }),
};
